import React from 'react';
import { ComplementaryInfoContainer } from '../components/ComplementaryInfoContainer';
import PremiumSection from '../components/PremiumSection';
import { ComplementaryInfoSection } from '../sections/ComplementaryInfoSection';
import { ServiceTypeSection } from '../sections/ServiceTypeSection';

export const TicketFormComplementaryInputsBlock = ({ ticketFormBodyData }) => {
  return (
    <>
      <ComplementaryInfoContainer>
        <PremiumSection>
          <ServiceTypeSection ticketFormBodyData={ticketFormBodyData} />
        </PremiumSection>
      </ComplementaryInfoContainer>
      <ComplementaryInfoContainer style={{ borderTop: '2px solid white' }}>
        <PremiumSection>
          <ComplementaryInfoSection ticketFormBodyData={ticketFormBodyData} />
        </PremiumSection>
      </ComplementaryInfoContainer>
    </>
  );
};
